import { BatchesService } from '@festina/legalentitydatareplicator-general-types/legalentitydatareplicator/services/BatchesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = BatchesService.batchesServicePostCreate
export type MethodParam = NonNullable<
  Parameters<typeof method>[0]['requestBody']
>

export const useSubmitLegalEntityDataReplicatorBatch = () =>
  useFestinaMutation({
    component: 'legalEntityDataReplicator',
    roles: BatchesService.batchesServicePostCreate_roles,
    isScenario: false,
    mutateFunction: async (arg: MethodParam) => {
      await method({ requestBody: arg })
    },
  })
